export default __webpack_public_path__ + "static/appStore-437ef265b13b632f996c009ad1216021.svg";